import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import BaseCliScript5 from '../../AbstractObjects/GatewayPlan/InnerPages/BaseCliScript5';

const pageSchema = GatewayGetSchema.pages.cliScript5;
const pageId = pageSchema.pageId;

function PlanCliScript5({
    planObject,
    setPlanData
}) {

    let pageData = planObject[pageId];
    
    return (
        <BaseCliScript5
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanCliScript5;